export default {
    timeList: [{
        dispValue: "8:00 AM",
        value: "28800000"
    }, {
        dispValue: "8:30 AM",
        value: "30600000"
    }, {
        dispValue: "9:00 AM",
        value: "32400000"
    }, {
        dispValue: "9:30 AM",
        value: "34200000"
    }, {
        dispValue: "10:00 AM",
        value: "36000000"
    }, {
        dispValue: "10:30 AM",
        value: "37800000"
    }, {
        dispValue: "11:00 AM",
        value: "39600000"
    }, {
        dispValue: "11:30 AM",
        value: "41400000"
    }, {
        dispValue: "12:00 PM",
        value: "43200000"
    }, {
        dispValue: "12:30 PM",
        value: "45000000"
    }, {
        dispValue: "1:00 PM",
        value: "46800000"
    }, {
        dispValue: "1:30 PM",
        value: "48600000"
    }, {
        dispValue: "2:00 PM",
        value: "50400000"
    }, {
        dispValue: "2:30 PM",
        value: "52200000"
    }, {
        dispValue: "3:00 PM",
        value: "54000000"
    }, {
        dispValue: "3:30 PM",
        value: "55800000"
    }, {
        dispValue: "4:00 PM",
        value: "57600000"
    }, {
        dispValue: "4:30 PM",
        value: "59400000"
    }, {
        dispValue: "5:00 PM",
        value: "61200000"
    }, {
        dispValue: "5:30 PM",
        value: "63000000"
    }, {
        dispValue: "6:00 PM",
        value: "64800000"
    }, {
        dispValue: "6:30 PM",
        value: "66600000"
    }, {
        dispValue: "7:00 PM",
        value: "68400000"
    }, {
        dispValue: "7:30 PM",
        value: "70200000"
    }, {
        dispValue: "8:00 PM",
        value: "72000000"
    }, {
        dispValue: "8:30 PM",
        value: "73800000"
    }, {
        dispValue: "9:00 PM",
        value: "75600000"
    }, {
        dispValue: "9:30 PM",
        value: "77400000"
    }],
    timeListText: [
        {
            dispValue: "12:00 AM",
            value: "12:00 AM"
        },{
            dispValue: "12:30 AM",
            value: "12:30 AM"
        },{
            dispValue: "1:00 AM",
            value: "1:00 AM"
        },{
            dispValue: "1:30 AM",
            value: "1:30 AM"
        },{
            dispValue: "2:00 AM",
            value: "2:00 AM"
        },{
            dispValue: "2:30 AM",
            value: "2:30 AM"
        },{
            dispValue: "3:00 AM",
            value: "3:00 AM"
        },{
            dispValue: "3:30 AM",
            value: "3:30 AM"
        },{
            dispValue: "4:00 AM",
            value: "4:00 AM"
        },{
            dispValue: "4:30 AM",
            value: "4:30 AM"
        },{
            dispValue: "5:00 AM",
            value: "5:00 AM"
        },{
            dispValue: "5:30 AM",
            value: "5:30 AM"
        },{
            dispValue: "5:30 AM",
            value: "5:30 AM"
        },{
            dispValue: "6:00 AM",
            value: "6:00 AM"
        },{
            dispValue: "6:30 AM",
            value: "6:30 AM"
        },{
            dispValue: "7:00 AM",
            value: "7:00 AM"
        },{
            dispValue: "7:30 AM",
            value: "7:30 AM"
        },
        {
        dispValue: "8:00 AM",
        value: "8:00 AM"
    }, {
        dispValue: "8:30 AM",
        value: "8:30 AM"
    }, {
        dispValue: "9:00 AM",
        value: "9:00 AM"
    }, {
        dispValue: "9:30 AM",
        value: "9:30 AM"
    }, {
        dispValue: "10:00 AM",
        value: "10:00 AM"
    }, {
        dispValue: "10:30 AM",
        value: "10:30 AM"
    }, {
        dispValue: "11:00 AM",
        value: "11:00 AM"
    }, {
        dispValue: "11:30 AM",
        value: "11:30 AM"
    }, {
        dispValue: "12:00 PM",
        value: "12:00 PM"
    }, {
        dispValue: "12:30 PM",
        value: "12:30 PM"
    }, {
        dispValue: "1:00 PM",
        value: "1:00 PM"
    }, {
        dispValue: "1:30 PM",
        value: "1:30 PM"
    }, {
        dispValue: "2:00 PM",
        value: "2:00 PM"
    }, {
        dispValue: "2:30 PM",
        value: "2:30 PM"
    }, {
        dispValue: "3:00 PM",
        value: "3:00 PM"
    }, {
        dispValue: "3:30 PM",
        value: "3:30 PM"
    }, {
        dispValue: "4:00 PM",
        value: "4:00 PM"
    }, {
        dispValue: "4:30 PM",
        value: "4:30 PM"
    }, {
        dispValue: "5:00 PM",
        value: "5:00 PM"
    }, {
        dispValue: "5:30 PM",
        value: "5:30 PM"
    }, {
        dispValue: "6:00 PM",
        value: "6:00 PM"
    }, {
        dispValue: "6:30 PM",
        value: "6:30 PM"
    }, {
        dispValue: "7:00 PM",
        value: "7:00 PM"
    }, {
        dispValue: "7:30 PM",
        value: "7:30 PM"
    }, {
        dispValue: "8:00 PM",
        value: "8:00 PM"
    }, {
        dispValue: "8:30 PM",
        value: "8:30 PM"
    }, {
        dispValue: "9:00 PM",
        value: "9:00 PM"
    },{
        dispValue: "9:30 PM",
        value: "9:30 PM"
    },{
        dispValue: "10:00 PM",
        value: "10:00 PM"
    },{
        dispValue: "10:30 PM",
        value: "10:30 PM"
    },{
        dispValue: "11:00 PM",
        value: "11:00 PM"
    },{
        dispValue: "11:30 PM",
        value: "11:30 PM"
    }],
    stateList: ["Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana", "Himachal Pradesh",
        "Jammu & Kashmir", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
        "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana", "Tripura", "Uttarakhand", "Uttar Pradesh",
        "West Bengal", "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli", "Daman & Diu", "Delhi", "Lakshadweep", "Puducherry"
    ],

    leadStatusList: [{
        value: "newleadentery",
        dispValue: "New Lead Entry"
    }, {
        value: "nocontact",
        dispValue: "No Contact"
    }, {
        value: "contact",
        dispValue: "Contact"
    }],

    Cnvrted: [{
        value: "converted",
        dispValue: "Converted"
    }],

    /***
     * This is for support 
     * When freh lead is created then user choose contact and callback then lead user can't be able to convert it fresh lead;
     */
    leadStatusListUpdate: [{
        value: "nocontact",
        dispValue: "No Contact"
    }, {
        value: "contact",
        dispValue: "Contact"
    }, ],


    appointmentStatus: [{
        value: "newappointment",
        dispValue: "New Appointment"
    }, {
        value: "followup",
        dispValue: "Follow Up"
    }, {
        value: "notintrested",
        dispValue: "Not Interested"
    }, {
        value: "notavailable",
        dispValue: "Not Available"
    }, {
        value: "wrngnumber",
        dispValue: "Wrong Number"
    }, {
        value: "convertd",
        dispValue: "Converted"
    }, {
        value: "renewalcollected",
        dispValue: "Renewal Collected"
    }],

    /**
     * @author Khan Usama
     * Date 15/10/2018
     * @description Here all number of arrays based on appointment disposition, dispositions based on 
     * appointment status "appointmentStatus"
     * 
     * example: when I choose followup on appointment status then appointment dispositions shows the list 
     * related to followup
     * 
     * Note:  Appointment Disposition fields is volatile or a dynamic. values are changed according to 
     * requirement, the important thing is all disposition array contains {text, value} it is must.
     */
    _appointDispoList: {

        newAppt: [{ value: "newApptmnt", dispValue: "New Appointment" }],
        // When Appointent and follow up
        followUp: [{
            value: 'metcustomer',
            dispValue: 'Met Customer, in follow up for closure'
        }, {
            value: 'notmet',
            dispValue: 'Not Met - Reschedule Appt'
        }],

        // When After appointment then not intrested
        _notIntrest: [{
            value: 'apptDenies',
            dispValue: 'Client denies giving appointment'
        }, {
            value: 'metFollowupNotIntrested',
            dispValue: 'Met, followed up, then not interested'
        }],

        // when Appointment and not available
        availableNot: [{ value: 'phoneNtAvailble', dispValue: 'Phone not available always' }],

        _fWrongNo: [{ value: 'Wrong_Number', dispValue: 'Wrong Number' }],
        converted: [{ value: "leadconverted", dispValue: "Convinced for a new policy" }],
        renCallBack: [{ value: "ConvinceRenPay", dispValue: "Convinced for renewal payment" }]
    },

    // Appointment Dispositons are ends here

    nonContact: [{
        value: "notreachable",
        dispValue: "Not reachable"
    }, {
        value: "ringingbusy",
        dispValue: "Ringing Busy"
    }, {
        value: "wrongnumber",
        dispValue: "Wrong number"
    }, {
        value: "invalid",
        dispValue: "Invalid Number"
    }, {
        value: "switchoff",
        dispValue: "Switched off"
    }],

    contact: [{
        value: "appointment",
        dispValue: "Appointment"
    }, {
        value: "callback",
        dispValue: "Callback"
    }, {
        value: "shorthangup",
        dispValue: "Short hang up"
    }, {
        value: "notinterested",
        dispValue: "Not Interested"
    }, {
        value: "nonserviceloc",
        dispValue: "Non Servicable location"
    }, {
        value: "noteligible",
        dispValue: "Not Eligible"
    }],


    callBack: [
        "Asked to call back later",
        "Decision maker unavailable",
        "ECS is active asked to call on due date",
    ],

    notIntrested: [
        "Not interested to Meet",
        "Did not Enquire",
        "Too Expensive",
        "Not interested to continue Existing Policy",
    ],
    notEligible: [
        "NE - Income",
        "NE - Age"
    ],

    appntment: [
        "Client has given appointment"
    ],

    // latest

    _aptSubDispList: {
        _appt: {
            newApptmnt: ['Untouched / Not updated Appointment']
        },
        followUp: {
            metcustomer: ["Met Customer, in follow up for closure"],
            notmet: ['Customer agreed to meet at another time', 'Not Met - Reschedule Appt as phone keeps on ringing']
        },
        N_I: {
            apptDenies: ["Client denies giving appointment"],
            metFollowupNotIntrested: ["Met, followed up, then not interested", "Bought policy from competition", "Wants to check options and buy online", "Lack of funds", "Interested in other investment tools"]
        },
        N_A: {
            phoneNtAvailble: ["Not reachable / no answer / switched off always"]
        },
        W_N: {
            Wrong_Number: ['Wrong Number']
        },
        Conv: {
            leadconverted: ['Successfully closed appt, Convinced for a new policy']
        },
        R_C: {
            ConvinceRenPay: ['Successfully closed appt, Convinced for renewal payment']
        }
    },

    notMetReschedAppt: [
        "Customer agreed to meet at another time",
        "Not Met - Reschedule Appt as phone keeps on ringing",
    ],

    metFollUpNI: [
        "Met, followed up, then not interested",
        "Bought policy from competition",
        "Wants to check options and buy online",
        "Lack of funds",
        "Interested in other investment tools",
    ],


    // Proposal details in lead
    // date 21/11/2018

    propsalDetails: {
        cardsList: [
            {
                title: 'Life Assured Details',
                _id: 'C1',
                route: '/master/testapp',
                list: [
                    {
                        label: 'Name',
                        data: ''
                    }, {
                        label: 'DOB',
                        data: ''
                    }, {
                        label: 'Gender',
                        data: ''
                    }, {
                        label: 'Employee No.',
                        data: ''
                    }, {
                        label: 'Mobile No.',
                        data: ''
                    }, {
                        label: 'Email ID',
                        data: ''
                    }
                ]
            },
            {
                title: 'Proposer Details',
                _id: 'C2',
                route: '/master/testpro/proposalpersonal',
                list: [
                    {
                        label: 'Name',
                        data: ''
                    }, {
                        label: 'DOB',
                        data: ''
                    }, {
                        label: 'Gender',
                        data: ''
                    }, {
                        label: 'Employee No.',
                        data: ''
                    }, {
                        label: 'Mobile No.',
                        data: ''
                    }, {
                        label: 'Email ID',
                        data: ''
                    }
                ]
            },
            {
                title: 'Appointee/Nominee Details',
                _id: 'C3',
                route: '/master/testpro/proposalnominee',
                list: [
                    {
                        label: 'DOB',
                        data: ''
                    }, {
                        label: 'Gender',
                        data: ''
                    }, {
                        label: 'Employee No.',
                        data: ''
                    }, {
                        label: 'Mobile No.',
                        data: ''
                    }, {
                        label: 'Email ID',
                        data: ''
                    }
                ]

            },
            {
                title: 'Plan Details',
                _id: 'C4',
                route: '/master/testapp',
                list: [
                    {
                        label: 'Plan Name',
                        data: ''
                    }, {
                        label: 'Plan Code Category',
                        data: ''
                    }, {
                        label: 'Policy Term',
                        data: ''
                    }, {
                        label: 'Premium Paying Term',
                        data: ''
                    }, {
                        label: 'Sum Assured',
                        data: ''
                    }
                ]
            }, 
            {
                title: 'Premium Details',
                _id: 'C5',
                route: '/master/testapp',
                list: [
                    {
                        label: 'Premium Name',
                        data: ''
                    }, {
                        label: 'Installment Premium',
                        data: ''
                    }, {
                        label: 'Annualized Premium',
                        data: ''
                    }, {
                        label: 'ECS/Direct/Debit',
                        data: ''
                    }, 
                ]
            }, 
            {
                title: 'Other Details',
                _id: 'C6',
                route: '/master/testapp',
                list: [
                   
                    {
                        label: 'Name',
                        data: ''
                    }, {
                        label: 'Code',
                        data: ''
                    }
                ]
            }, 
            {
                title: 'Payment Details',
                _id: 'C7',
                route: '/master/testapp',
                list: [
                    {
                        label:'Installment Premium',
                        data: ''
                    },
                    {
                        label: 'Payment Mode',
                        data: ''
                    }, {
                        label: 'Recorded Amount',
                        data: ''
                    }, {
                        label: 'Bank Name',
                        data: ''
                    }, {
                        label: 'Branch Name',
                        data: ''
                    }, {
                        label: 'Mobile No.',
                        data: ''
                    }, {
                        label: 'Email ID',
                        data: ''
                    }
                ]
            }
        ]
    }
}